import { Action, createFeatureSelector, createReducer, createSelector, on } from '@ngrx/store';
import { AuthActions } from './index';

export const authFeatureKey = 'auth';
export interface AuthState {
  loading: boolean;
  authHeaders: any;
}

const initialState: AuthState = {
  loading: false,
  authHeaders: {
    accessToken: null,
    client: null,
    expiry: null,
    tokenType: null,
    uid: null
  }
};

const reducer = createReducer<AuthState>(
  initialState,
  on(AuthActions.AuthLoading, (state, action) => ({ ...state, loading: action.loading }))
);

export function authReducer(state: AuthState | undefined, action: Action) {
  return reducer(state, action);
}

export const selectAuthState = createFeatureSelector<AuthState>(authFeatureKey);

export const selectLoadState = createSelector(
  selectAuthState,
  (state) => state.loading
);
